export default {
  setBankInfo: (state, data) => {
    state.bankInfo = data;
  }
};
